// state/index.js - VERSION CORRIGÉE
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  mode: "dark",
  userId: "63701cc1f03239b7f700000e",
  token: null,
  user: null,
  isAuthenticated: false,
};

// Fonction pour charger depuis localStorage
const loadFromStorage = () => {
  try {
    const token = localStorage.getItem("access_token");
    const userStr = localStorage.getItem("user");
    
    if (token && userStr) {
      const user = JSON.parse(userStr);
      return {
        token,
        user,
        isAuthenticated: true,
        userId: user?.id || initialState.userId,
      };
    }
  } catch (error) {
    console.error("Erreur chargement localStorage:", error);
  }
  return null;
};

// Charger l'état initial depuis localStorage
const storedState = loadFromStorage();
if (storedState) {
  initialState.token = storedState.token;
  initialState.user = storedState.user;
  initialState.isAuthenticated = storedState.isAuthenticated;
  initialState.userId = storedState.userId;
}

export const globalSlice = createSlice({
  name: "global",
  initialState,
  reducers: {
    setMode: (state) => {
      state.mode = state.mode === "light" ? "dark" : "light";
    },
    setLogin: (state, action) => {
      const { token, user } = action.payload;
      
      if (token && user) {
        state.token = token;
        state.user = user;
        state.userId = user?.id || state.userId;
        state.isAuthenticated = true;
        
        // Stocker dans localStorage (unifié)
        localStorage.setItem("access_token", token);
        localStorage.setItem("user", JSON.stringify(user));
      } else {
        // Déconnexion
        state.token = null;
        state.user = null;
        state.isAuthenticated = false;
        
        // Nettoyer localStorage
        localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");
        localStorage.removeItem("user");
      }
    },
    setLogout: (state) => {
      state.token = null;
      state.user = null;
      state.isAuthenticated = false;
      
      // Nettoyer localStorage
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("user");
    },
    setUser: (state, action) => {
      state.user = action.payload;
      state.userId = action.payload?.id || state.userId;
      
      if (action.payload) {
        localStorage.setItem("user", JSON.stringify(action.payload));
      }
    },
  },
});

// Export des actions et du reducer
export const { setMode, setLogin, setLogout, setUser } = globalSlice.actions;
export default globalSlice.reducer; // Export par défaut